// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const SET_SERVERS_MIGRATION_LIST = 'servers-migration/SET_SERVERS_MIGRATION_LIST';
export const REMOVE_SERVERS_MIGRATION_ITEM = 'servers-migration/REMOVE_SERVERS_MIGRATION_ITEM';
export const REMOVE_SERVERS_MIGRATION_ITEMS = 'servers-migration/REMOVE_SERVERS_MIGRATION_ITEMS';
export const UPDATE_SERVERS_MIGRATION_TASK = 'servers-migration/UPDATE_SERVERS_MIGRATION_TASK';
export const SERVERS_MIGRATION_ADD_ITEM = 'servers-migration/SERVERS_MIGRATION_ADD_ITEM';
export const SET_SERVERS_MIGRATION_ITEM_IS_DELETING = 'servers-migration/SET_SERVERS_MIGRATION_ITEM_IS_DELETING';
export const SET_SERVERS_MIGRATION_PRE_CHECK = 'servers-migration/SET_SERVERS_MIGRATION_PRE_CHECK';
